import * as React from 'react';
import { useDispatch } from 'react-redux';

import { handleAuthorizationCallbackActionCreator } from 'app/page/auth/redux/auth-action-creators';

const AuthCallbackPage = (): null => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(handleAuthorizationCallbackActionCreator());
    }, [dispatch]);

    return null;
};

export { AuthCallbackPage };
